export const extractTranslations = (data: unknown) => {
  // @ts-expect-error -- data are correctly unknown
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- data are correctly unknown
  const translations = data.translations[0];

  if (translations === null || translations === undefined) {
    return data;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- data are correctly unknown
  const seo = translations.seo?.[0]?.item ?? translations.seo;

  if (seo !== null && seo !== undefined) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- data are correctly unknown
    translations.seo = seo.length === 0 ? null : seo;
  }
  // @ts-expect-error -- data are correctly unknown
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return -- data are correctly unknown
  return { ...data, translations };
};

export const extractBlocks = (data: unknown) =>
  // @ts-expect-error -- data are correctly unknown
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- data are correctly unknown
  ({ ...data, blocks: (Array.isArray(data.blocks) ? data.blocks : []).map((block) => block.item.collection[0]) });
